import { render, staticRenderFns } from "./TableItemLvl1.vue?vue&type=template&id=090e113c"
import script from "./TableItemLvl1.vue?vue&type=script&lang=js"
export * from "./TableItemLvl1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports